export enum preferencesActions {
  Captions_Enable = 'Captions_Enable',
  Captions_Disable = 'Captions_Disable',
  TTSSettings_Set = 'TTSSettings_Set',
}

export const enableCaptions = {
  type: preferencesActions.Captions_Enable,
};
export const disableCaptions = {
  type: preferencesActions.Captions_Disable,
};
